import {
	type LoaderFunctionArgs,
	type ActionFunctionArgs,
	redirect,
} from '@remix-run/node'
import { Form, useActionData, json, Outlet } from '@remix-run/react'
import { parse } from 'csv-parse/sync'
import { Button } from '#app/components/ui/button.js'
import { InventoryService } from '#app/services/inventory.server.js'
import { getUserId } from '#app/utils/auth.server.js'
import { prisma } from '#app/utils/db.server.js'
import { extractEntities } from '#app/utils/huggingface-server.ts'
import { useIsPending } from '#app/utils/misc.js'

export async function action({ request }: ActionFunctionArgs) {
	const formData = await request.formData()
	const invoice = {
		items: [
			{
				description: 'HAM PIT BNLS HICKORY SMKD BERKSHIRE 1/12-16 LB CS ONLY',
				quantity: 3,
				currency: null,
				unit_price: 7.19,
				total_price: 400.27,
			},
			{
				description:
					'TURKEY BREAST NETTED ROAST RAW FRZN 2/9 LB CS ONLY BNLS/SKNLS FERNDALE RWA',
				quantity: 12,
				currency: null,
				unit_price: 5.69,
				total_price: 1296.81,
			},
			{
				description:
					"BACON APPLEWOOD DUROC SCLD 5MM 12 LB CS AVG NEESVIG'S ABF",
				quantity: 12,
				currency: null,
				unit_price: 9.99,
				total_price: 1438.26,
			},
			{
				description: "BACON APPLEWOOD LAYOUT 10-14 37723 1/15 LB CS DAILY'S",
				quantity: 3,
				currency: null,
				unit_price: 5.99,
				total_price: 269.55,
			},
			{
				description:
					'DUCK BREAST BNLS S/ON MEDIUM 6.5-9.5 OZ 24110000 3581096 24/6.5-9.5 OZ CS MAPLE LEAF',
				quantity: 2,
				currency: null,
				unit_price: 15.99,
				total_price: 386.48,
			},
			{
				description: 'GLACE DEMI DUE VEAL (VEAL) 7.5LB CASE CUSTOM CULINARY',
				quantity: 1,
				currency: null,
				unit_price: 129.99,
				total_price: 129.99,
			},
		],
		subtotal: 3921.36,
		tax: null,
		total: 3921.36,
		currency: 'USD',
		notes:
			'SERVICE ENTRANCE TO LEFT OF MAIN DOORS\nGO STRAIGHT AND DOWN STAIRS TO THE LEFT\n2ND COOLER ON THE LEFT IN BASEMENT',
		others: {
			customer_code: '78120',
			salesperson: 'Nick M - WI',
			po_number: '3 / 74',
			deliver_via: 'Route / Stop',
		},
	}

	const cleanedItems = []
	for (const item of invoice.items) {
		const extractedEntities = await extractEntities(item.description)
		console.log({ extractedEntities })
		cleanedItems.push({
			originalDescription: item.description,
			extractedEntities,
		})
	}

	return {
		cleanedItems,
	}
}

export const loader = async ({ request }: LoaderFunctionArgs) => {
	return {}
}

const UploadInventory = () => {
	const data = useActionData<typeof action>()
	const isPending = useIsPending()

	console.log(data)
	return (
		<div className=" font-regular font-source-sans-pro">
			<div className="px-6 py-24 sm:px-6 sm:py-32 lg:px-8">
				<div className="mx-auto max-w-2xl text-center">
					<h2 className="font-source-sans-pro text-3xl font-black font-bold tracking-tight text-gray-900 sm:text-4xl ">
						Upload your inventory<br></br>to update stock
						<br />
					</h2>
					<div className="mt-10 flex items-center justify-center gap-x-6">
						<Form
							className="w-full max-w-[500px]"
							method="post"
							encType="multipart/form-data"
						>
							<div className="mb-8">
								<input
									type="file"
									name="media"
									className="focus:ring-secondary-orange bg-off-white block w-full rounded-md border-0 py-1.5 text-black shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6"
									accept=".csv"
								/>
							</div>
							<Button>
								{isPending ? 'Uploading Inventory...' : 'Upload Inventory'}
							</Button>
						</Form>
					</div>
					<p className="mt-8 text-base leading-7 text-gray-600">
						Currently accepts CSV format.
					</p>
					{data?.error && (
						<div className="mt-4 text-red-600">
							<p>{data.error}</p>
						</div>
					)}{' '}
				</div>
			</div>
			<Outlet />
		</div>
	)
}

export default UploadInventory

export function CatchBoundary() {
	return (
		<div>
			<h1></h1>
			<p>Something went wrong - please reload the page or try again</p>
		</div>
	)
}
